import { elements } from './elements.js';
import { state, setState } from './state.js';
import { updateVideoSource } from './utils.js';
import initStickyPanels from './sticky-panels.js';

const initOnResize = () => {
    setState();
    if (elements.stickyPanelContainer) initStickyPanels(elements.stickyPanelContainer);
    if (elements.stackedImages.length) {
        updateVideoSource(elements.stackedImages, state.breakpoint);
    }
};

export { initOnResize as default };
